module.exports = __webpack_public_path__ + "img/times-square.b8cafd0d.svg";